import { round } from "./round";

export const getPercent = (value: number, precision: number = 2) =>
  round((value - 1) * 100, precision);

/**
 * Calculate what percentage one amount is of a total
 * @param amount The amount to calculate percentage for
 * @param total The total amount
 * @param precision Decimal precision (default 2)
 * @returns Formatted percentage string (e.g., "50.00" or "0")
 */
export const getPortionPercent = (
  amount: number,
  total: number,
  precision: number = 2
): string => {
  return total > 0 ? ((amount / total) * 100).toFixed(precision) : "0";
};
